export const DATE_FORMAT = {
    dateSlash: 'yyyy/MM/dd',
    dateDash: 'yyyy-MM-dd',
    dateTime: 'yyyy-MM-dd HH:mm',
};
export const availableTo = '22:00';
export const availableFrom = '07:00';
